<template>
  <div class="main-project-statistics">
    <el-card
      shadow="never"
      class="card-fix-height scrollable"
      header="项目概况"
      :style="{ 'max-height': '15rem' }"
    >
      <el-row class="statistics" :gutter="20">
        <el-col :span="6">
          <div class="pro" :style="'background-image: url(' + xm1 + ')'">
            <div
              style="margin: 15px 0 0 25px;color: #fff;font-size: 42px;line-height: 42px;text-align: left;"
            >
              {{ statisInfo.openedCount }}
            </div>
            <div
              style="font-size: 22px;font-weight: normal;width: 200px;text-align: right;position: absolute;bottom: 15px;right: 20px;color: #FFFFFF;"
            >
              已发布的项目
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="pro" :style="'background-image: url(' + xm2 + ')'">
            <div
              style="margin: 15px 0 0 25px;color: #fff;font-size: 42px;line-height: 42px;text-align: left;"
            >
              {{ statisInfo.suspendCount }}
            </div>
            <div
              style="font-size: 22px;font-weight: normal;width: 200px;text-align: right;position: absolute;bottom: 15px;right: 20px;color: #FFFFFF;"
            >
              已暂停项目
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card
      shadow="never"
      class="card-fix-height scrollable"
      header="收益总览"
      :style="{ 'max-height': '15rem' }"
    >
      <el-row class="statistics" :gutter="20">
        <el-col :span="6">
          <div
            class="pro sy"
            :style="'background-image: url(' + sy1 + ')'"
            @click="getOrder('today')"
          >
            <div
              style="margin: 15px 0 0 25px;color: #fff;font-size: 42px;line-height: 42px;text-align: left;"
            >
              {{ earnings.todayEarnings || 0 }}
            </div>
            <div
              style="font-size: 22px;font-weight: normal;width: 200px;text-align: right;position: absolute;bottom: 0px;right: 20px;color: #FFFFFF;"
            >
              本日收益
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div
            class="pro sy"
            :style="'background-image: url(' + sy2 + ')'"
            @click="getOrder('week')"
          >
            <div
              style="margin: 15px 0 0 25px;color: #fff;font-size: 42px;line-height: 42px;text-align: left;"
            >
              {{ earnings.weekEarnings || 0 }}
            </div>
            <div
              style="font-size: 22px;font-weight: normal;width: 200px;text-align: right;position: absolute;bottom: 0px;right: 20px;color: #FFFFFF;"
            >
              本周收益
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div
            class="pro sy"
            :style="'background-image: url(' + sy3 + ')'"
            @click="getOrder('month')"
          >
            <div
              style="margin: 15px 0 0 25px;color: #fff;font-size: 42px;line-height: 42px;text-align: left;"
            >
              {{ earnings.monthEarnings || 0 }}
            </div>
            <div
              style="font-size: 22px;font-weight: normal;width: 200px;text-align: right;position: absolute;bottom: 0px;right: 20px;color: #FFFFFF;"
            >
              本月收益
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div
            class="pro sy"
            :style="'background-image: url(' + sy4 + ')'"
            @click="getOrder"
          >
            <div
              style="margin: 15px 0 0 25px;color: #fff;font-size: 42px;line-height: 42px;text-align: left;"
            >
              {{ earnings.allEarnings || 0 }}
            </div>
            <div
              style="font-size: 22px;font-weight: normal;width: 200px;text-align: right;position: absolute;bottom: 0px;right: 20px;color: #FFFFFF;"
            >
              累计收益
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card
      shadow="never"
      class="card-fix-height scrollable top20"
      header="收益统计"
      style="overflow: hidden"
    >
      <el-row class="button">
        <el-col :span="3">
          <el-select
            v-model="incomeForm.agentId"
            placeholder="机构"
            clearable
            :default-first-option="true"
            filterable
          >
            <el-option
              v-for="(item, i) in agentList"
              :key="i + '-agentId'"
              :label="item.agentName"
              :value="item.agentId"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" id="income-search">
          <el-button
            type="primary"
            @click="onSearchIncome"
            icon="el-icon-search"
            >查询</el-button
          >
        </el-col>
        <el-col :span="8">
          <div>
            <el-radio-group v-model="incomeForm.incomeDate">
              <el-radio-button label="today">本日</el-radio-button>
              <el-radio-button label="week">本周</el-radio-button>
              <el-radio-button label="month">本月</el-radio-button>
              <el-radio-button label="all">累计</el-radio-button>
            </el-radio-group>
            <el-button
              style="margin-left: 30px"
              type="primary"
              @click="downloadAgentIncomeTree"
              icon="el-icon-download"
              >导出</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-table
        :data="agentPager.agentIncomeTreeData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="agentId"
        stripe
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        max-height="500"
      >
        <el-table-column
          prop="agentName"
          label="机构名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="attribute"
          label="属性"
          align="center"
          :formatter="attributeFormatter"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="level" label="层级" align="center">
        </el-table-column>
        <el-table-column
          prop="parentName"
          label="所属上级"
          align="center"
          :formatter="parentNameFormatter"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="allIncome" label="总收益" align="center">
          <template slot-scope="scope">
            <span
              class="income"
              @click="viewIncome('all', scope.row.agentId)"
              >{{ scope.row.allIncome }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="teamIncome" label="团队收益" align="center">
          <template slot-scope="scope">
            <span
              class="income"
              @click="viewIncome('team', scope.row.agentId)"
              >{{ scope.row.teamIncome }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="selfIncome" label="本部收益" align="center">
          <template slot-scope="scope">
            <span
              class="income"
              @click="viewIncome('self', scope.row.agentId)"
              >{{ scope.row.selfIncome }}</span
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="footer"
        background
        :layout="tableLayout"
        :total="agentPager.tableTotal"
        :current-page="agentPager.currentPage"
        :page-size.sync="pageSize"
        @current-change="onGetDetailPager"
        @size-change="handleSizeChange"
        :page-sizes="[20, 100, 500]"
        align="center"
      >
      </el-pagination>
    </el-card>
    <el-card
      shadow="never"
      class="card-fix-height scrollable top20"
      header="项目详细统计"
      style="overflow: hidden"
    >
      <el-row class="button">
        <el-col :span="6" id="myselfAgent">
          <select-tree
            size="small"
            :data="agentTreeData"
            clearable
            checkStrictly
            @getValue="setTreeMenu"
            :multiple="true"
            :collapseTags="true"
            :defaultKey="searchForm.agentIds"
          ></select-tree>
        </el-col>
        <el-col :span="5" id="btn">
          <el-button
            type="primary"
            @click="onSearchFormDetailPager"
            icon="el-icon-search"
            >查询</el-button
          >
          <el-button
            type="primary"
            @click="downloadProjectDetail"
            icon="el-icon-download"
            >导出</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="projectPager.tableData"
        v-loading="projectPager.loading"
        row-key="id"
        stripe
        style="width: 100%;"
        max-height="500"
        show-summary
      >
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="projectCode"
          label="项目编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="agentName"
          label="机构"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sumUserCount"
          label="测评人数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="finishedCount"
          label="完成人数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sumPayCount"
          label="支付人数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sumCertificateCount"
          label="发证人数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="activitedCount"
          label="入库人数"
          align="center"
        ></el-table-column>
        <el-table-column prop="projectIncome" label="项目收益" align="center">
          <template slot-scope="scope">
            <span class="income" @click="viewProjectIncome(scope.row)">{{
              scope.row.projectIncome || 0
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户详情" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="项目详情"
              placement="top-start"
            >
              <el-button
                icon="el-icon-view"
                type="primary"
                size="mini"
                circle
                @click="onGetProjectUser(scope.row)"
              ></el-button>
              >
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="footer"
        background
        :layout="tableLayout"
        :total="projectPager.tableTotal"
        :current-page="projectPager.currentPage"
        :page-size.sync="pageSize"
        @current-change="onGetDetailPager"
        @size-change="handleSizeChange"
        :page-sizes="[20, 100, 500]"
        align="center"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      title="参与项目用户信息"
      :visible.sync="projectUserVisible"
      width="50%"
    >
      <el-table
        :data="projectUserPager.tableData"
        v-loading="projectUserPager.loading"
      >
        <el-table-column
          prop="realName"
          label="用户姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="idNumber"
          label="证件号码"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="storageStatus"
          label="入库状态"
          align="center"
          :formatter="storageStatusFormatter"
        ></el-table-column>
        <el-table-column label="查看" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="查看证书"
              placement="top-start"
            >
              <el-button
                icon="el-icon-view"
                type="primary"
                size="mini"
                circle
                @click="viewCer(scope.row)"
              ></el-button>
              >
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="查看测评详情"
              placement="top-start"
            >
              <el-button
                icon="el-icon-view"
                type="primary"
                size="mini"
                circle
                @click="findUserAssess(scope.row)"
              ></el-button>
              >
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="footer"
        background
        :layout="tableLayout"
        :total="projectUserPager.tableTotal"
        :current-page="projectUserPager.currentPage"
        :page-size.sync="pageSize"
        @current-change="onUserPageChange"
        @size-change="handleSizeChange2"
        :page-sizes="[20, 100, 500]"
        align="center"
        v-if="projectUserPager.tableTotal > 0"
      >
      </el-pagination>
    </el-dialog>
    <el-dialog title="测评详情" :visible.sync="userAssessVisible" width="35%">
      <el-table :data="userScaleList">
        <el-table-column
          label="量表名称"
          prop="scaleName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="测评时间"
          prop="submitTime"
          align="center"
        ></el-table-column>
        <el-table-column
          label="测评状态"
          prop="userScaleStatus"
          align="center"
        ></el-table-column>
        <el-table-column
          fixed="right"
          label="测评报告"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.submitTime"
              @click="findAssessReport(scope.row)"
              type="text"
              size="small"
              >查看</el-button
            >
            <span v-else>暂无</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  profile,
  projectList,
  detailPager,
  getProjectUserPager,
  downloadProjectDetail
} from "@/api/projectInfo";
import { getScaleListByProId } from "@/api/userAssess";
import {
  downloadAgentIncomeTree,
  getAgentIncomTreePager
} from "@/api/projectStatistics";
import { getEarnings } from "@/api/orderInfo";
import { getCerCode } from "@/api/userCertificate";
import { getAgentChildAll } from "@/api/userInfo";
import permission from "@/directive/permission"; // 权限判断指令
import { defaultPageConfig } from "@/config/pagination";
import { getExamUrl } from "@/api/auth";
import xm1 from "../../assets/image/xm1.png";
import xm2 from "../../assets/image/xm2.png";
import sy1 from "../../assets/image/sy1.png";
import sy2 from "../../assets/image/sy2.png";
import sy3 from "../../assets/image/sy3.png";
import sy4 from "../../assets/image/sy4.png";
import { getAgentTree } from "@/api/agentInfo";
import selectTree from "@/components/selectTree";

export default {
  name: "projectStatic",
  directives: { permission },
  components: {
    selectTree
  },
  data: function() {
    return {
      xm1: xm1,
      xm2: xm2,
      sy1: sy1,
      sy2: sy2,
      sy3: sy3,
      sy4: sy4,
      searchForm: {
        id: null,
        agentIds: []
      },
      statisInfo: {
        createdCount: 0,
        openedCount: 0,
        unAuthoCount: 0,
        suspendCount: 0
      },
      projectPager: {
        tableData: [],
        currentPage: 1,
        tableTotal: -1,
        tablePages: 0,
        loading: false
      },
      projectUserPager: {
        id: null,
        agentName: null,
        tableData: [],
        currentPage: 1,
        tableTotal: -1,
        tablePages: 0,
        loading: false
      },
      auditStatusOptions: [
        { label: "已通过", value: 1 },
        { label: "未通过", value: 2 },
        { label: "未审核", value: 3 }
      ],
      loading: false,
      projectUserVisible: false,
      tableLayout: defaultPageConfig.layout,
      pageSize: defaultPageConfig.pageSize,
      projectList: [],
      agentList: [],
      userAssessVisible: false,
      userScaleList: [],
      pcUrl: null,
      earnings: {},
      agentTreeData: [],
      incomeForm: {
        agentId: null,
        incomeDate: "all"
      },
      agentPager: {
        agentIncomeTreeData: [],
        currentPage: 1,
        tableTotal: 0,
        tablePages: 0,
        loading: false
      }
    };
  },
  watch: {
    "incomeForm.incomeDate"() {
      this.onSearchIncome();
    }
  },
  computed: {
    dialogTitle() {
      if (this.isFormEdit) {
        return "更新用户";
      } else {
        return "新增用户";
      }
    }
  },
  created() {
    this.getAgentChildAll();
    if (localStorage.getItem("pcUrl") && localStorage.getItem("gUrl")) {
      this.pcUrl = localStorage.getItem("pcUrl");
    } else {
      this.getExamUrl();
    }
    this.getAgentIncomTree();
    let that = this;
    setTimeout(function() {
      that.getAgentTree();
    }, 2000);
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    setTreeMenu(key, data) {
      if (!key) {
        this.searchForm.agentIds = [];
      } else {
        this.searchForm.agentIds = key;
      }
    },
    handleSizeChange() {
      this.getDetailPager();
    },
    handleSizeChange2() {
      this.onGetProjectUser();
    },
    // 查询项目概况
    onProfile(agentIds) {
      if (!agentIds) {
        agentIds = this.searchForm.agentIds;
      }
      let that = this;
      that.loading = true;
      profile(agentIds)
        .then(res => {
          if (res && res.code === 200) {
            that.statisInfo = res.data;
            that.getProjectList();
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    downloadProjectDetail() {
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let agentIds = this.searchForm.agentIds;
      downloadProjectDetail(agentIds)
        .then(res => {
          if (!res) {
            this.$message.error("下载文件失败");
            return false;
          }
          const blob = new Blob([res.data], {
            type: "application/octet-stream"
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          let result = patt.exec(contentDisposition);
          let filename = decodeURI(result[1]);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .finally(function() {
          loading.close();
        });
    },
    storageStatusFormatter(row, column, cellValue) {
      let status = {
        "1": "未入库",
        "2": "审核中",
        "3": "已入库",
        "4": "已过期"
      };
      return status[cellValue];
    },
    // 查询所有项目列表
    getProjectList() {
      let that = this;
      projectList().then(res => {
        if (res && res.code === 200) {
          that.projectList = res.data;
        } else {
          that = projectList = [];
        }
      });
    },
    // 查询项目统计分页
    getDetailPager(id, agentIds) {
      if (!agentIds) {
        agentIds = this.searchForm.agentIds;
      }
      let that = this;
      detailPager(id, agentIds, {
        page: that.projectPager.currentPage,
        pageSize: that.pageSize
      }).then(res => {
        if (res && res.code === 200) {
          that.projectPager.tableTotal = Number(res.data.total);
          that.projectPager.tablePages = Number(res.data.pages);
          that.projectPager.tableData = res.data.list || [];
        }
      });
    },
    // 查询项目统计分页
    searchFormDetailPager(id, agentIds) {
      let that = this;
      that.projectPager.loading = true;
      detailPager(id, agentIds, {
        page: that.projectPager.currentPage,
        pageSize: that.pageSize
      })
        .then(res => {
          if (res && res.code === 200) {
            that.projectPager.tableTotal = Number(res.data.total);
            that.projectPager.tablePages = Number(res.data.pages);
            that.projectPager.tableData = res.data.list || [];
          }
        })
        .finally(() => {
          that.projectPager.loading = false;
        });
    },
    onGetDetailPager(page) {
      this.projectPager.currentPage = page;
      this.getDetailPager(this.searchForm.id, this.searchForm.agentIds);
    },
    onSearchFormDetailPager() {
      this.projectPager.currentPage = 1;
      this.searchFormDetailPager(this.searchForm.id, this.searchForm.agentIds);
      this.onProfile();
      /*this.getEarnings(this.searchForm.agentIds);*/
    },
    onGetProjectUser(row) {
      let that = this;
      var myId, myAgentName;
      if (row && row.id && row.agentName) {
        that.projectUserPager.id = row.id;
        that.projectUserPager.agentName = row.agentName;
        myId = row.id;
        myAgentName = row.agentName;
      } else {
        myId = that.projectUserPager.id;
        myAgentName = that.projectUserPager.agentName;
      }
      that.projectUserPager.loading = true;
      that.projectUserVisible = true;
      getProjectUserPager({
        projectId: myId,
        agentName: myAgentName,
        page: that.projectUserPager.currentPage,
        pageSize: that.pageSize
      })
        .then(res => {
          if (res && res.code === 200) {
            that.projectUserPager.tableData = res.data.list || [];
            that.projectUserPager.tableTotal = Number(res.data.total);
            that.projectUserPager.tablePages = Number(res.data.pages);
          } else {
            that.projectUserPager.tableData = [];
            that.projectUserPager.tableTotal = 0;
            that.projectUserPager.tablePages = 0;
          }
        })
        .finally(() => {
          that.projectUserPager.loading = false;
        });
    },
    // 用户翻页
    onUserPageChange(page) {
      this.projectUserPager.currentPage = page;
      this.onGetProjectUser(this.projectUserPager.id);
    },
    getAgentChildAll() {
      getAgentChildAll().then(res => {
        if (res.code === 200 && res.data) {
          this.agentList = res.data;
          this.searchForm.agentIds.push(this.agentList[0].agentId);
          this.getDetailPager();
          this.onProfile(this.searchForm.agentIds);
          this.getEarnings(this.searchForm.agentIds);
        }
      });
    },
    viewCer(cerInfo) {
      var params = {};
      params.userId = cerInfo.userId;
      params.projectId = cerInfo.projectId;
      getCerCode(params).then(res => {
        if (res && res.code === 200) {
          if (res.data.certificateCode) {
            var cerCode = this.encryption(res.data.certificateCode);
            window.open(this.pcUrl + "certificate?certificateCode=" + cerCode);
          } else {
            this.$message({
              message: "证书不存在！",
              type: "warinig"
            });
          }
        } else {
          this.$message({
            message: "证书不存在！",
            type: "warinig"
          });
        }
      });
    },
    findUserAssess(row) {
      let that = this;
      that.userAssessVisible = true;
      getScaleListByProId({
        projectId: row.projectId,
        userId: row.userId
      }).then(res => {
        if (res && res.code === 200) {
          that.userScaleList = res.data.map(item => {
            if (item.submitTime) {
              item.userScaleStatus = "已测评";
              if (item.submitTime.length >= 10) {
                item.submitTime = item.submitTime.substring(0, 10);
              }
            } else {
              item.userScaleStatus = "未测评";
            }
            return item;
          });
        }
      });
    },
    findAssessReport(row) {
      window.open(this.pcUrl + "report?userScaleId=" + row.userScaleId);
    },
    encryption(code) {
      var c = String.fromCharCode(code.charCodeAt(0) + code.length);
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
      }
      return escape(c);
    },
    getExamUrl() {
      getExamUrl().then(res => {
        if (res && res.code === 200) {
          if (res.data.pcUrl && res.data.gUrl) {
            localStorage.setItem("pcUrl", res.data.pcUrl);
            this.pcUrl = res.data.pcUrl;
            localStorage.setItem("gUrl", res.data.gUrl);
            this.gUrl = res.data.gUrl;
          }
          if (res.data.h5Url) {
            localStorage.setItem("h5Url", res.data.h5Url);
          }
        }
      });
    },
    getEarnings(agentIds) {
      if (!agentIds) {
        agentIds = this.searchForm.agentIds;
      }
      getEarnings(agentIds).then(res => {
        if (res && res.data) {
          this.earnings = res.data;
        }
      });
    },
    getOrder(param) {
      let query = {};
      if (param && param == "today") {
        query.param = param;
      } else if (param && param == "week") {
        query.param = param;
      } else if (param && param == "month") {
        query.param = param;
      }
      this.jumpPage({ path: "/order/orderInfo", query: query });
    },
    jumpPage(router) {
      this.$router.push(router);
    },
    getAgentTree() {
      let that = this;
      getAgentTree(this.searchForm, {}).then(res => {
        if (res && res.code === 200) {
          that.agentTreeData = res.data;
        }
      });
    },
    getAgentIncomTree() {
      let that = this;
      getAgentIncomTreePager(this.incomeForm, {
        page: this.agentPager.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        if (res && res.code == 200) {
          if (!res.data.list || res.data.list.length < 1) {
            that.agentPager.agentIncomeTreeData = [];
            that.agentPager.tableTotal = 0;
            that.agentPager.tablePages = 1;
          } else {
            that.agentPager.agentIncomeTreeData = res.data.list.map(item => {
              this.getLeafCountTree(item);
              return item;
            });
            that.agentPager.tableTotal = Number(res.data.total);
            that.agentPager.tablePages = Number(res.data.pages);
          }
        }
      });
    },
    getLeafCountTree(json) {
      if (!json.children || json.children.length < 1) {
        json.num = 1;
        return 1;
      } else {
        var leafCount = 1;
        for (var i = 0; i < json.children.length; i++) {
          leafCount = leafCount + this.getLeafCountTree(json.children[i]);
        }
        json.num = leafCount;
        return leafCount;
      }
    },
    parentNameFormatter(row) {
      if (!row.parentName) {
        return "暂无";
      } else {
        return row.parentName;
      }
    },
    attributeFormatter(row) {
      if (!row.attribute) {
        return "暂无";
      } else {
        return row.attribute;
      }
    },
    onSearchIncome() {
      this.incomeDateFormatter(this.incomeForm.incomeDate);
      this.getAgentIncomTree();
    },
    incomeDateFormatter(param) {
      if (param && param == "today") {
        let now = new Date();
        let year = now.getFullYear();
        let m = now.getMonth() + 1;
        let date = now.getDate();
        let t = year + "-" + m + "-" + date;
        this.incomeForm.startTime = t;
        this.incomeForm.endTime = t;
      } else if (param && param == "week") {
        let date = new Date();
        // 本周一的日期
        date.setDate(date.getDate() - date.getDay() + 1);
        let begin =
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate() +
          " 00:00:00";
        date.setDate(date.getDate() + 6);
        let end =
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate() +
          " 23:59:59";
        this.incomeForm.startTime = begin;
        this.incomeForm.endTime = end;
      } else if (param && param == "month") {
        let date = new Date();
        date.setDate(1);
        let year = date.getFullYear();
        let m = date.getMonth() + 1;
        let one = date.getDate();
        let first = year + "-" + m + "-" + one;
        let currentMonth = date.getMonth();
        let nextMonth = ++currentMonth;
        let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
        let oneDay = 1000 * 60 * 60 * 24;
        let lastDay = new Date(nextMonthFirstDay - oneDay).getDate();
        let last = year + "-" + m + "-" + lastDay;
        this.incomeForm.startTime = first;
        this.incomeForm.endTime = last;
      } else {
        this.incomeForm.startTime = null;
        this.incomeForm.endTime = null;
      }
    },
    viewIncome(param, agentId) {
      let query = {
        incomeParam: param,
        agentId: agentId,
        param: this.incomeForm.incomeDate
      };
      this.jumpPage({
        path: "/order/orderInfo",
        query: { income: JSON.stringify(query) }
      });
    },
    viewProjectIncome(row) {
      this.jumpPage({
        path: "/order/orderInfo",
        query: { projectName: row.projectName }
      });
    },
    downloadAgentIncomeTree() {
      this.incomeDateFormatter(this.incomeForm.incomeDate);
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      downloadAgentIncomeTree(this.incomeForm)
        .then(res => {
          if (!res) {
            this.$message.error("下载文件失败");
            return false;
          }
          const blob = new Blob([res.data], {
            type: "application/octet-stream"
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          let result = patt.exec(contentDisposition);
          let filename = decodeURI(result[1]);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .finally(function() {
          loading.close();
        });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.main-project-statistics {
  .statistics {
    .el-col {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .pro {
        list-style: none;
        display: inline-block;
        position: relative;
        width: 320px;
        height: 80px;
        margin: 0 12px;
        -moz-border-radius: 15px;
        -webkit-border-radius: 15px;
        border-radius: 15px;
        .el-row {
          margin: 10px 0;
        }
      }
    }
  }
  .income {
    color: red;
    cursor: pointer;
  }
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  ::-webkit-scrollbar {
    background-color: #f8f8ff;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #dedfe9;
  }
  .card-fix-height {
    position: relative;
    /*height: calc(100vh - 50px - 84px - 15px - 40px - 51px - 52px - 2px - 30px);*/
    max-height: 700px;
  }
  .button {
    padding-bottom: 20px;
  }
  .top20 {
    margin-top: 20px;
    /*height: calc(100vh - 84px - 15px - 242px - 2px - 30px);*/
    max-height: 700px;
  }

  .el-col#myselfAgent {
    width: 16%;
  }

  .el-col#myselfAgent .el-select {
    width: 230px;
    #myselfAgent .el-select__tags-text {
      display: inline-block;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .el-row .el-col#btn {
    margin-left: 90px;
  }
  .el-row .el-col#income-search {
    .el-button--primary {
      margin-left: 30px;
    }
  }
  .sy:hover {
    cursor: pointer;
  }
}
</style>
